export const NoClassesText = [
  "Пар немає",
  "Чудовий день (бо пар нема)",
  "Просили передати, що пар не буде",
  "Пар не буде, сьогодні чілимо",
  "Академ. вихідний",
]
